import { useQuery } from '@tanstack/react-query';

import { AllowList } from 'src/features/allowList/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/allow-lists/allow-list/:listId/';

type QueryFnType = typeof queryFn;

type DTO = {
    listId: string;
    parkingId: string;
};

const queryFn = ({ listId, parkingId }: DTO): Promise<AllowList> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, listId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_ALLOW_LIST_RESOURCE, useQueryHook as useGetAllowList };
